import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { VariantColor } from '@repo/toolkit/colors'
import { SVGFC } from '@repo/toolkit/types'
import Navbar from '@repo/ui/navbar'
import TranslationDropdown from '@repo/ui/translation-dropdown'

import useAuth from '../../lib/hooks/use-auth'
import useTranslate from '../../lib/hooks/use-translate'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import NotificationsToggler from './notification-toggler'
import UserMenu from './user-menu'

interface NavBarProps {
  title: string | React.ReactNode
  icon: SVGFC
  badgeTitle?: string
  badgeVariant?: VariantColor
  phrase?: string
  phraseVariant?: VariantColor
  onIconClick?: () => void
}

const UserNavBar: React.FC<NavBarProps> = ({
  icon,
  title,
  badgeTitle,
  badgeVariant,
  phrase,
  phraseVariant,
  onIconClick
}) => {
  const { user, userRole } = useAuth()
  const { currentLanguage, i18n } = useTranslate()

  const showNotifications = user && user.role !== RoleEnum.Ol

  return (
    <Navbar
      icon={icon}
      title={title}
      phrase={phrase}
      onIconClick={onIconClick}
      badgeTitle={badgeTitle}
      badgeVariant={badgeVariant}
      phraseVariant={phraseVariant}
    >
      <div className="flex flex-row items-center gap-2">
        {showNotifications && <NotificationsToggler />}
        {userRole === RoleEnum.STAFF && (
          <TranslationDropdown
            language={currentLanguage}
            onLanguageChange={(language) => i18n.changeLanguage(language)}
            color={tailwindColors.grey.DEFAULT}
          />
        )}
        {userRole !== RoleEnum.CLIENT && <UserMenu />}
      </div>
    </Navbar>
  )
}

export default UserNavBar
